import loading from '../helpers/loading'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    bank: {},
    kyc: {}
  },
  mutations: {
    ...loading.mutations,
    updateBank: (state, { bank }) => (state.bank = bank),
    updateKyc: (state, { kyc }) => (state.kyc = kyc)
  },
  getters: {
    ...loading.getters,
    bank: state => ({ ...state.bank }),
    kyc: state => ({ ...state.kyc })
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/bank/index.js